import { gql } from '@apollo/client';
import {
  leasingIncomeSchemaDetailFragment,
  leasingIncomeSchemaFragment,
  leasingIncomeSchemaXPartnerFragment,
  leasingIncomeSchemaPropertyFragment,
  leasingIncomeSchemaXGroupFragment
} from './fragments';

export const LEASING_INCOME_SCHEMAS = gql`
  query leasingIncomeSchemas($pager: PagerInputNew, $filters: LeasingIncomeSchemaFilters) {
    leasingIncomeSchemas(pager: $pager, filters: $filters) {
      total
      values {
        id
        code
        name
        isActive
        stateId
        stateName
        isDeletable
      }
    }
  }
`;

export const LEASING_INCOME_SCHEMA = gql`
  query leasingIncomeSchema($id: Int!) {
    leasingIncomeSchema(id: $id) {
      ...leasingIncomeSchema
    }
  }
  ${leasingIncomeSchemaFragment}
`;

export const LEASING_INCOME_SCHEMA_STATE = gql`
  query leasingIncomeSchemaState($id: Int!) {
    leasingIncomeSchemaState(id: $id) {
      id
      name
      flowId
    }
  }
`;

export const LEASING_INCOME_SCHEMA_NEXT_STATES = gql`
  query leasingIncomeSchemaNextStates($stateId: Int!) {
    leasingIncomeSchemaNextStates(stateId: $stateId) {
      id
      name
    }
  }
`;

export const LEASING_INCOME_SCHEMA_STATE_HISTORY = gql`
  query leasingIncomeSchemaStateHistory($id: Int!) {
    leasingIncomeSchemaStateHistory(id: $id) {
      schemaId
      flowId
      stateId
      stateName
      transitionMoment
      nextTransitionMoment
      userId
      userName
    }
  }
`;

export const LEASING_INCOME_SCHEMA_DETAILS = gql`
  query leasingIncomeSchemaDetails($id: Int!) {
    leasingIncomeSchemaDetails(id: $id) {
      ...leasingIncomeSchemaDetail
    }
  }
  ${leasingIncomeSchemaDetailFragment}
`;

export const ENTITY_EVENTS = gql`
  query entityEvents {
    entityEvents {
      id
      name
    }
  }
`;

export const LEASING_EXPENSE_TYPES = gql`
  query leasingExpenseTypesCollection {
    leasingExpenseTypesCollection {
      id
      code
      name
      currencyId
      currencyCode
      currencyName
      useFormula
    }
  }
`;

export const LEASING_INCOME_SCHEMA_PROPERTIES = gql`
  query leasingIncomeSchemaProperties($id: Int!) {
    leasingIncomeSchemaProperties(id: $id) {
      ...leasingIncomeSchemaProperty
    }
  }
  ${leasingIncomeSchemaPropertyFragment}
`;

export const LEASING_INCOME_SCHEMA_PARTNERS = gql`
  query leasingIncomeSchemaXPartners($id: Int!) {
    leasingIncomeSchemaXPartners(id: $id) {
      ...leasingIncomeSchemaXPartner
    }
  }
  ${leasingIncomeSchemaXPartnerFragment}
`;

export const LEASING_INCOME_SCHEMA_GROUPS = gql`
  query leasingIncomeSchemaXGroups($id: Int!) {
    leasingIncomeSchemaXGroups(id: $id) {
      ...leasingIncomeSchemaXGroup
    }
  }
  ${leasingIncomeSchemaXGroupFragment}
`;

export const PARTNER_HIERARCHY_DETAILS = gql`
  query partnerHierarchyDetails($search: String) {
    partnerHierarchyDetails(search: $search) {
      partnerHierarchyDetailId
      parentDetailId
      category
      parentCategory
    }
  }
`;

export const LEASING_EXPENSE_MEASURING_UNIT = gql`
  query leasingExpenseMeasuringUnits {
    leasingExpenseMeasuringUnits {
      id
      name
    }
  }
`;

export const LEASING_EXPENSE_NEGOTIATION_MOMENTS = gql`
  query leasingExpenseNegotiationMoments {
    leasingExpenseNegotiationMoments {
      id
      name
    }
  }
`;
